/**
 * デジタルサイネージ種別
 * @module app/signage/DisplayType
 */
define([
    'module',
    'dojo/store/Memory'
    // 以下、変数で受けないモジュール
], function(module, Memory) {
    // シングルトンを返す
    return new Memory({
        idProperty: 'code',
        data: [
            {'code':1, 'label':'災害対応状況'},
            {'code':2, 'label':'避難所概況'},
            {'code':3, 'label':'個別避難所一覧'},
            {'code':4, 'label':'避難情報概況'},
            {'code':5, 'label':'避難情報履歴'},
            {'code':6, 'label':'被害情報概況'},
            {'code':7, 'label':'個別被害情報一覧'},
            {'code':8, 'label':'体制概況'},
            {'code':9, 'label':'クロノロジ概況'},
            {'code':10, 'label':'個別クロノロジ一覧'},
            {'code':11, 'label':'気象情報'},
            {'code':12, 'label':'観測状況概況'},
            {'code':13, 'label':'地震・津波'},
            {'code':14, 'label':'ライフライン'},
            // NOTICE: 地図画面は現在非表示にしている
            // {'code':15, 'label':'地図'},
            {'code':16, 'label':'主題図（避難・避難所）'},
        ]
    });
});
